'use strict';

export default class Deferred {
  constructor() {
    this._settled = false;
    this._promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  resolve(stuff) {
    if (this._settled) return;
    this._settled = true;
    this._resolve(stuff);
  }

  reject(err) {
    if (this._settled) return;
    this._settled = true;
    this._reject(err);
  }

  get promise() {
    return this._promise;
  }

  get settled() {
    return this._settled;
  }
}
